module.exports = __webpack_public_path__ + "img/estado_icono.11f5cdfd.svg";